import { GetSiteSetupsForDateQuery, SiteSetupFragmentFragment } from 'data/__generated__';
import { SITE_SETUP_FRAGMENT } from 'data/fragments/siteSetup';
import { apolloClient } from '../../../App';
import { GET_SITE_SETUPS_FOR_DATE_QUERY } from 'data/queries/siteSetup';

export const siteSetupCreatedHandler = (createdSiteSetup: SiteSetupFragmentFragment) => {
    // We can read query only if it has been run

    const result = apolloClient.readQuery<GetSiteSetupsForDateQuery>({
        query: GET_SITE_SETUPS_FOR_DATE_QUERY,
        variables: {
            date: createdSiteSetup.date,
        },
    });
    if (result === null) {
        return;
    }
    const currentSiteSetups = result.getSiteSetupsForDate;

    // if the current site setups already contains the created one, then we need to update it with the sent values (and keep it at the same index)
    const newSiteSetups = currentSiteSetups.find(({ _id }) => _id === createdSiteSetup._id)
        ? currentSiteSetups.map((siteSetup) => (siteSetup._id === createdSiteSetup._id ? createdSiteSetup : siteSetup))
        : [...currentSiteSetups, createdSiteSetup];

    apolloClient.writeQuery({
        query: GET_SITE_SETUPS_FOR_DATE_QUERY,
        data: { getSiteSetupsForDate: newSiteSetups },
        variables: {
            date: createdSiteSetup.date,
        },
    });
};

export const siteSetupUpdatedHandler = (updatedSiteSetup: SiteSetupFragmentFragment) => {
    // We can read query only if it has been run
    const siteSetupCached = apolloClient.readFragment({
        id: `SiteSetup:${updatedSiteSetup._id}`,
        fragment: SITE_SETUP_FRAGMENT,
        fragmentName: 'SiteSetupFragment',
    });

    if (siteSetupCached) {
        apolloClient.writeFragment({
            id: `SiteSetup:${updatedSiteSetup._id}`,
            fragment: SITE_SETUP_FRAGMENT,
            fragmentName: 'SiteSetupFragment',
            data: {
                ...updatedSiteSetup,
            },
        });
    }
};
